import { Indicator } from '../../../Common/Charts/Indicator';
import { useAttentionChartsDataContext } from './hooks/useAttentionChartsDataContext';

export const NormalBirths = () => {
    const { chartData } = useAttentionChartsDataContext();

    return (
        <Indicator
            title={'Indice de Partos Normais'}
            indicatorValue={chartData?.indicators?.normalBirths}
            className='aligned-container'
            goalValue={85}
            goalMessage='Meta Aceitável - acima de 85%'
        />
    );
};
